import { IStoredQueryItem } from 'utils/types';

export const convertStoredQueryToParams = (items: IStoredQueryItem[]) => {
  return items.reduce((acc, item) => {
    if (acc[item.key]) {
      acc[item.key] = [
        ...(Array.isArray(acc[item.key]) ? acc[item.key] : [acc[item.key]]),
        item.value,
      ];
    } else {
      acc[item.key] = item.value;
    }

    return acc;
  }, {} as any);
};

export const convertParamsToStoredQuery = (params: {
  [key: string]: string | string[] | undefined;
}) => {
  return Object.keys(params).reduce((acc, name) => {
    if (!params[name]) {
      return acc;
    }

    if (Array.isArray(params[name])) {
      return [
        ...acc,
        ...(params[name] as string[]).map((item) => ({
          key: name,
          value: item,
        })),
      ];
    }

    return [...acc, { key: name, value: params[name] as string }];
  }, [] as IStoredQueryItem[]);
};
